const NAME = "GALLERY_DIALOG";

export default NAME;
